import * as React from "react";
import { ActiveIconProps } from "../../../interface/activeicon.interface";

export const CloseIcon: React.FC<ActiveIconProps> = ({ isActive }) =>
  isActive ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="13"
      fill="none"
      viewBox="0 0 11 11"
    >
      <path
        stroke="#fff"
        strokeLinecap="round"
        d="m10 1.195-9 9M10 10.195 1.2 1"
      ></path>
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="11"
      fill="none"
      viewBox="0 0 11 11"
    >
      <path
        stroke="#000"
        strokeLinecap="round"
        d="m10 1.195-9 9M10 10.195 1.2 1"
      ></path>
    </svg>
  );
